export const inputColors = {
  backgroundDefault: 'rgba(243, 244, 246, 1)',
  borderDefault: 'rgba(243, 244, 246, 1)',

  backgroundOnHover: 'rgba(231, 233, 240, 1)',
  borderOnHover: 'rgba(231, 233, 240, 1)',

  backgroundFocused: 'white',
  borderFocused: 'rgba(0, 223, 95, 1)',

  backgroundDisabled: 'rgba(243, 244, 246, 1)',
  borderDisabled: 'rgba(243, 244, 246, 1)',

  errorMain: 'rgba(247, 64, 97, 1)',
  errorBackground: 'rgba(247, 64, 97, 0.03)',

  textDefault: 'rgba(44, 45, 46, 1)',
  textDisabled: 'rgba(93, 94, 100, 1)',
  hint: 'rgba(135, 137, 143, 1)',

  caret: 'rgba(0, 223, 95, 1)'
}

export const inputFonts = {
  mainFont: 'Lato-Regular, sans-serif'
}